// PageBar — the in-page title-bar archetype (DESIGN_LANGUAGE.md §7.2).
// ONE chassis for every page/pane header in the product; per-app headers
// (DocsHeader, CalHeader, TicketsHeader, AnalyticsHeader, ChatPaneHeader…)
// become configurations of this, not components. The contract comes from
// the 2026-08-06 chat pane-header convergence, generalized:
//
// - geometry: padding 'Z A', minHeight 'D', root gap 'A', side-group gap 'Z1'
// - BORDERLESS: no hairline underline — headers separate by whitespace and
//   fill contrast (§2.5); the PageHeader hairline is retired with migration
// - title = PageBarTitle ('A' / 700, ellipsis) · meta = PageBarMeta ('Y2'
//   caption, ellipsis) · icon actions = PageBarBtn (fixed B1 box, quiet
//   until the house `hover` wash)
//
// Slots: fill `Left` (back affordance + title + meta), `Center` (tabs /
// segmented nav — absent by default), `Right` (actions rail). Self-contained
// on purpose: unlike ChatPaneHeader (which extends the workspace shell's
// PageHeader and therefore only resolves in-shell), PageBar carries its own
// chassis so standalone apps (marketplace, preview) get the same bar.

export const PageBarTitle = {
  tag: 'h2',
  margin: '0',
  fontSize: 'A',
  fontWeight: '700',
  color: 'title',
  minWidth: '0',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}

export const PageBarMeta = {
  tag: 'span',
  fontSize: 'Y2',
  color: 'caption',
  minWidth: '0',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}

export const PageBarBtn = {
  extends: 'IconButton',
  boxSize: 'B1',
  alignSelf: 'center',
  flexShrink: '0',
  round: 'radiusPill',
  background: 'transparent',
  color: 'caption',
  ':hover': { background: 'hover', color: 'title' }
}

export const PageBar = {
  tag: 'header',
  flow: 'x',
  align: 'center space-between',
  gap: 'A',
  minHeight: 'D',
  padding: 'Z A',
  width: '100%',
  boxSizing: 'border-box',

  Left: {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    minWidth: '0',
    flex: '1'
  },

  Right: {
    flow: 'x',
    align: 'center right',
    gap: 'Z1',
    flexShrink: '0'
  }
}
